import ApolloLinkTimeout from "apollo-link-timeout-dynamic";
import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  WatchQueryFetchPolicy,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { authenticationClient } from "@eolas-medical/core";

const timeoutLink = new ApolloLinkTimeout({ timeout: 20000 });

const authLink = setContext(async (_, { headers }) => {
  const token = await authenticationClient.getToken();
  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
  };
});

const fetchPolicy: WatchQueryFetchPolicy = "network-only";

const makeApolloOptions = (apiUrl: string) => {
  const httpLink = new HttpLink({
    uri: apiUrl,
  });
  return {
    link: ApolloLink.from([timeoutLink, authLink, httpLink]),
    cache: new InMemoryCache({
      addTypename: false,
    }),
    defaultOptions: {
      query: {
        fetchPolicy,
      },
      watchQuery: {
        fetchPolicy,
      },
    },
  };
};

export const makeApolloClient = (apiUrl: string) => {
  return new ApolloClient(makeApolloOptions(apiUrl));
};
